import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { AppDispatch } from "../../../core/data/redux/store";
import { getFaq } from "../../../core/data/redux/action";
import { RootState } from "../../../core/data/redux/store";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";

const Faq = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getFaq({ search: "" }));
  }, []);

  const { faqList } = useSelector((state: RootState) => ({
    faqList: state.faq.faqList,
  }));

  const routes = all_routes;

  const faqStyles = {
    heading: {
      fontSize: "36px",
      lineHeight: "50px",
      marginBottom: "30px",
    },

    faqItem: {
      marginTop: "20px",
      marginBottom: "20px",
    },
    questionRow: {
      display: "flex",

      justifyContent: "space-between",
      cursor: "pointer",
      padding: "10px 0",
    },
    question: {
      fontSize: "18px",
      lineHeight: "28px",
      margin: 0,
      color: "#23233C",
    },
    arrow: {
      fontSize: "16px",
    },
    answer: {
      fontSize: "14px",
      color: "#777",
      marginTop: "5px",
      padding: "5px 0",
    },
    divider: {
      borderTop: "1px solid #ddd",
      marginTop: "5px",
    },
  };

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index: any) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <section className="faq-sections pt-4 px-2">
        <div className="container">
          <div className="faq-info">
            <div className="sign-group">
              <Link
                to={routes.homeOne}
                className="px-0 mx-0 mb-2 border-0 btn sign-up d-flex align-items-center"
              >
                <i className="bx bx-arrow-back fs-5 me-2"></i>
                <span className="mt-1"> Back To Home </span>
              </Link>
            </div>
            <h1>FAQs</h1>

            {faqList?.map((faq: any, index: any) => (
              <div key={index} style={faqStyles.faqItem}>
                <div
                  onClick={() => toggleFAQ(index)}
                  style={faqStyles.questionRow}
                >
                  <p style={faqStyles.question}>{faq.question}</p>
                  <span style={faqStyles.arrow}>
                    {openIndex === index ? (
                      <ImageWithBasePath
                        className="icon-img"
                        src="assets/img/home/arrow down.svg"
                        alt="Choose Locations"
                      />
                    ) : (
                      <ImageWithBasePath
                        className="icon-img "
                        src="assets/img/home/arrow down.svg"
                        alt="Choose Locations"
                      />
                    )}
                  </span>
                </div>

                {openIndex === index && (
                  <div style={faqStyles.answer}>
                    <div
                      className="fqList"
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    />{" "}
                  </div>
                )}

                <div style={faqStyles.divider}></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
